import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('UI error', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback) return this.props.fallback;
    return (
      <div className="m-4 card text-center">
        <p className="mb-2 text-lg font-semibold">Что-то пошло не так</p>
        <p className="mb-3 text-sm text-tg-hint">{this.state.error.message}</p>
        <button
          className="btn-primary"
          onClick={() => window.location.reload()}
        >
          Перезагрузить
        </button>
      </div>
    );
  }
}
